import { Component, Input } from '@angular/core';

@Component({
  selector: 'card-video',
  templateUrl: 'card-video.html'
})
export class CardVideoComponent {

  @Input() url: string;
  show: boolean;

  constructor() { }

  close() {
    this.show = false;
  }

  reproduceVideo() {
    this.show = true;
  }

}



// WEBPACK FOOTER //
// ./src/components/card-video/card-video.ts